<template>
  <div
    v-if="label != null"
    ref="element"
    class="TextObject"
    @contextmenu="handleClickDestroTextObject($event)"
  >
    {{ src.Text }}
    <CollectorComponents
      v-for="(child, i) in src._children"
      @resize="label.resize"
      :parentOffset="label.offset"
      :src="child"
      :type="child._tipo"
      :key="i"
    />
  </div>
</template>
<script>
// import CollectorComponents from "./CollectorComponents.vue";
import LabelComponent from "@/classes/LabelComponent.js";

export default {
  name: "TextObject",
  props: {
    src: Object,
    parentOffset: Object,
  },
  components: {
    CollectorComponents: () => import("./CollectorComponents.vue"),
  },
  data() {
    return {
      label: null,
    };
  },
  methods: {
    handleClickDestroTextObject(e) {
      e.preventDefault();
      if (!this.isDynamicText()) {
        document
          .getElementById("mainCardText")
          .dispatchEvent(
            new CustomEvent("clickTextObject", { detail: this.src })
          );
      }
    },
    isDynamicText() {
      if (this.src.Text == null) {
        return false;
      }
      return this.src.Text.includes("[") && this.src.Text.includes("]");
    },
  },
  mounted() {
    this.label = new LabelComponent(this);

    this.$nextTick(() => {
      const style = {
        backgroundImage: `url('data:image/jpeg;base64,${
          this.src.FillImageData && this.src.FillImageData != null
            ? this.src.FillImageData
            : ""
        }')`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        border: "1px solid gray",
        display: "inline-block",
        fontFamily:
          this.src.Font && this.src.Font != null
            ? this.src.Font.split(", ")[0]
            : "Arial",
        fontSize:
          this.src.Font && this.src.Font != null
            ? this.src.Font.split(", ").length >= 2
              ? parseInt(this.src.Font.split(", ")[1]) + "pt"
              : "10pt"
            : "10pt",
        fontWeight: this.src.Font
          ? this.src.Font.split("style=").length >= 2
            ? this.src.Font.split("style=")[1]
            : "normal"
          : "normal",
        height: this.src.Height == null ? "auto" : this.src.Height + "px",
        left: this.src.Left == null ? "0" : this.src.Left + "px",
        lineHeight: this.src.Font.split(", ")[1],
        marginBottom:
          this.src.BottomMargin === null ? "0px" : this.src.BottomMargin + "px",
        marginLeft:
          this.src.LeftMargin === null ? "0px" : this.src.LeftMargin + "px",
        marginRight:
          this.src.RightMargin === null ? "0px" : this.src.RightMargin + "px",
        marginTop:
          this.src.TopMargin === null ? "0px" : this.src.TopMargin + "px",
        overflow: "hidden",
        paddingLeft: "2px",
        paddingright: "2px",
        position: "absolute",
        textAlign: "left",
        top: this.src.Top == null ? "0" : this.src.Top + "px",
        width: this.src.Width == null ? "auto" : this.src.Width + "px",
        boxSizing: "border-box",
        pointerEvents: this.isDynamicText() ? "none" : "",
        color: this.isDynamicText() ? "transparent" : "black",
      };

      this.label.getStyle(style);
      this.label.rendered = true;
    });
  },
};
</script>
<style scoped>
</style>
